import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip, img, Table, Person } from "./kit";
import { baseURL, secretKey } from "../../util/config";

// oda arka plani (customFrame/admin/roomBg)
const bgReq = async (path, opt = {}) => {
  const r = await fetch(`${baseURL}customFrame/admin/${path}`, { ...opt, headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "" } });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};

/// Yonetim (resmi) odalari: AYVO adina acilan odalar. Bolgesi secilir (sadece Araplar / sadece Turkiye / herkes),
/// sabitlenebilir, kullanici ID'si ile oda yoneticisi (personel) atanir. Oda yoneticileri odayi kapatamaz.
const GRUP = { ar: "Sadece Araplar", tr: "Sadece Türkiye", pk: "Sadece Pakistan", all: "Herkes" };

const OfficialRooms = () => {
  const [rooms, setRooms] = useState([]);
  const [msg, setMsg] = useState("");
  const [yeni, setYeni] = useState({ title: "", group: "", seatCount: 10, pinned: true });
  const [kod, setKod] = useState({});
  const [yasak, setYasak] = useState({});

  const [bg, setBg] = useState({});
  const load = () =>
    api.officialRooms().then(async (r) => {
      if (!r?.status) return;
      setRooms(r.rooms || []);
      const ids = (r.rooms || []).map((x) => x._id).join(",");
      if (ids) {
        const b = await bgReq(`roomBg?ids=${ids}`);
        if (b?.status) setBg(b.bg);
      }
    });
  const bgYukle = async (room, file) => {
    const fd = new FormData();
    if (file) fd.append("image", file);
    const r = await bgReq(`roomBg/${room._id}`, { method: "POST", body: fd });
    if (!r?.status) return window.alert(r?.message || "Yüklenemedi");
    setBg({ ...bg, [room._id]: r.bg });
    setMsg(file ? `"${room.title}" arka planı değişti` : `"${room.title}" varsayılan arka plana döndü`);
  };
  useEffect(() => {
    load();
  }, []);

  const sonuc = (r, tamam) => {
    setMsg(r?.status ? tamam || r.message || "Tamam" : r?.message || "Olmadı");
    if (r?.status) load();
  };

  const olustur = async () => {
    const r = await api.createOfficialRoom(yeni);
    sonuc(r, "Oda açıldı");
    if (r?.status) setYeni({ ...yeni, title: "" });
  };

  return (
    <>
      <PageHead
        title="Yönetim odaları"
        sub="AYVO adına resmi odalar aç. Her odanın hangi bölgede görüneceğini seç, sabitle ve personel ata. Personel odada her şeyi yapabilir ama odayı kapatamaz."
        right={msg ? <span style={{ fontSize: 13, color: "#16A34A" }}>{msg}</span> : null}
      />
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-body">
          <h6 style={{ fontWeight: 800 }}>Yeni oda aç</h6>
          <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <input className="form-control" style={{ maxWidth: 240 }} placeholder="Oda adı" value={yeni.title} onChange={(e) => setYeni({ ...yeni, title: e.target.value })} />
            <select className="form-control" style={{ maxWidth: 180 }} value={yeni.group} onChange={(e) => setYeni({ ...yeni, group: e.target.value })}>
              {/* bolge bilerek secilsin: varsayilan yanlis bolgeye oda acilmasin */}
              <option value="" disabled>Bölge seç</option>
              {Object.entries(GRUP).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
            <select className="form-control" style={{ maxWidth: 120 }} value={yeni.seatCount} onChange={(e) => setYeni({ ...yeni, seatCount: Number(e.target.value) })}>
              {[5, 10, 15, 20, 30].map((n) => <option key={n} value={n}>{n} koltuk</option>)}
            </select>
            <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0 }}>
              <input type="checkbox" checked={yeni.pinned} onChange={(e) => setYeni({ ...yeni, pinned: e.target.checked })} /> Sabitle
            </label>
            <button className="btn btn-primary" disabled={yeni.title.trim().length < 2 || !yeni.group} onClick={olustur}>Oda aç</button>
          </div>
        </div>
      </div>

      {rooms.map((r) => (
        <div className="card" key={r._id} style={{ marginBottom: 12, opacity: r.isActive ? 1 : 0.6 }}>
          <div className="card-body">
            <div className="d-flex" style={{ gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              <b style={{ fontSize: 16 }}>{r.title}</b>
              <Chip kind={r.isActive ? "ok" : "bad"}>{r.isActive ? "Açık" : "Kapalı"}</Chip>
              {r.pinOrder > 0 && <Chip kind="wait">Sabit</Chip>}
              <span className="d-flex align-items-center" style={{ gap: 6 }}>
                <img
                  src={img(bg[r._id] || "storage/ayvobot/bg_ayvo.jpg")}
                  alt=""
                  title="Oda arka planı"
                  style={{ width: 34, height: 60, objectFit: "cover", borderRadius: 6, border: "1px solid #E5E7EB" }}
                />
                <label className="btn btn-sm btn-outline-primary" style={{ margin: 0 }}>
                  Arka plan yükle
                  <input type="file" accept="image/*" hidden onChange={(e) => e.target.files?.[0] && bgYukle(r, e.target.files[0]) && (e.target.value = "")} />
                </label>
                {bg[r._id] && (
                  <button className="btn btn-sm btn-link" style={{ padding: 0 }} onClick={() => window.confirm("Varsayılan arka plana dönülsün mü?") && bgYukle(r, null)}>
                    varsayılan
                  </button>
                )}
              </span>
              <select
                className="form-control"
                style={{ maxWidth: 120, marginInlineStart: "auto" }}
                title="Koltuk sayısı"
                value={r.seatCount || 10}
                onChange={async (e) => {
                  const n = Number(e.target.value);
                  if (n < (r.seatCount || 10) && !window.confirm(`Koltuk ${n}'a düşsün mü? Fazla koltuklardakiler kalkar.`)) return;
                  sonuc(await api.updateOfficialRoom(r._id, { seatCount: n }), `Koltuk sayısı ${n} oldu`);
                }}
              >
                {[5, 10, 15, 20, 30].map((n) => <option key={n} value={n}>{n} koltuk</option>)}
              </select>
              <select
                className="form-control"
                style={{ maxWidth: 170 }}
                value={r.regionGroup || "all"}
                onChange={async (e) => sonuc(await api.updateOfficialRoom(r._id, { group: e.target.value }), "Bölge güncellendi")}
              >
                {Object.entries(GRUP).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
              <button className="btn btn-sm btn-outline-secondary" onClick={async () => sonuc(await api.updateOfficialRoom(r._id, { pinned: !(r.pinOrder > 0) }), r.pinOrder > 0 ? "Sabit kaldırıldı" : "Sabitlendi")}>
                {r.pinOrder > 0 ? "Sabiti kaldır" : "Sabitle"}
              </button>
              <button
                className={`btn btn-sm ${r.isActive ? "btn-outline-danger" : "btn-outline-success"}`}
                onClick={async () => (!r.isActive || window.confirm(`"${r.title}" kapatılsın mı?`)) && sonuc(await api.updateOfficialRoom(r._id, { isActive: !r.isActive }), r.isActive ? "Oda kapatıldı" : "Oda açıldı")}
              >
                {r.isActive ? "Kapat" : "Tekrar aç"}
              </button>
            </div>
            <div style={{ fontSize: 12, color: "#6B7280", margin: "10px 0 6px" }}>Personel (oda yöneticileri)</div>
            <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", alignItems: "center" }}>
              {(r.staff || []).map((s) => (
                <span key={s.userId} className="d-inline-flex" style={{ alignItems: "center", gap: 6, padding: "4px 6px 4px 4px", borderRadius: 20, background: "#EEF2FF" }}>
                  {s.image ? <img src={img(s.image)} alt="" style={{ width: 22, height: 22, borderRadius: 11, objectFit: "cover" }} /> : null}
                  <b style={{ fontSize: 13 }}>{s.name}</b>
                  <span style={{ fontSize: 12, color: "#6B7280" }}>ID {s.uniqueID}</span>
                  <button className="btn btn-sm btn-link text-danger" style={{ padding: "0 4px" }} onClick={async () => sonuc(await api.officialRoomStaff(r._id, { code: s.uniqueID || s.userId, remove: true }))}>
                    ✕
                  </button>
                </span>
              ))}
              <input className="form-control" style={{ maxWidth: 150 }} placeholder="Kullanıcı ID" value={kod[r._id] || ""} onChange={(e) => setKod({ ...kod, [r._id]: e.target.value })} />
              <button
                className="btn btn-sm btn-primary"
                disabled={!(kod[r._id] || "").trim()}
                onClick={async () => {
                  sonuc(await api.officialRoomStaff(r._id, { code: kod[r._id].trim() }));
                  setKod({ ...kod, [r._id]: "" });
                }}
              >
                + Personel ekle
              </button>
            </div>
            <div style={{ fontSize: 12, color: "#B91C1C", margin: "12px 0 6px" }}>Giriş yasağı (bu ID'ler odaya giremez)</div>
            <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", alignItems: "center" }}>
              {(r.banned || []).map((s) => (
                <span key={s.userId} className="d-inline-flex" style={{ alignItems: "center", gap: 6, padding: "4px 6px 4px 4px", borderRadius: 20, background: "#FEE2E2" }}>
                  {s.image ? <img src={img(s.image)} alt="" style={{ width: 22, height: 22, borderRadius: 11, objectFit: "cover" }} /> : null}
                  <b style={{ fontSize: 13 }}>{s.name}</b>
                  <span style={{ fontSize: 12, color: "#6B7280" }}>ID {s.uniqueID}</span>
                  <button className="btn btn-sm btn-link text-success" style={{ padding: "0 4px" }} title="Yasağı kaldır" onClick={async () => sonuc(await api.officialRoomDeny(r._id, { code: s.uniqueID || s.userId, remove: true }))}>
                    ✕
                  </button>
                </span>
              ))}
              <input className="form-control" style={{ maxWidth: 150 }} placeholder="Kullanıcı ID" value={yasak[r._id] || ""} onChange={(e) => setYasak({ ...yasak, [r._id]: e.target.value })} />
              <button
                className="btn btn-sm btn-danger"
                disabled={!(yasak[r._id] || "").trim()}
                onClick={async () => {
                  sonuc(await api.officialRoomDeny(r._id, { code: yasak[r._id].trim() }));
                  setYasak({ ...yasak, [r._id]: "" });
                }}
              >
                + Yasak ekle
              </button>
            </div>
          </div>
        </div>
      ))}
      {!rooms.length && <div className="badu-empty">Henüz yönetim odası yok. Yukarıdan ilk odayı aç.</div>}
      <MicTrack />
    </>
  );
};

// ------------------------------------------------------------------ mikrofon takibi
const sure = (dk) => {
  const m = Math.round(Number(dk) || 0);
  return m >= 60 ? `${Math.floor(m / 60)} sa ${m % 60} dk` : `${m} dk`;
};
const gecen = (d) => (d ? sure((Date.now() - new Date(d).getTime()) / 60000) : "—");

/// Sesli odalarda koltuktaki herkes: su an mikrofon acik mi, ne zamandir oturuyor; donemde kac saat
/// koltukta kaldi, bunun ne kadari mikrofon acik. Sunucu her dakika sayar (voiceRoom/micTrack.js).
const MicTrack = () => {
  const [f, setF] = useState({ region: "all", days: 1, q: "", official: "" });
  const [d, setD] = useState({ now: [], totals: [] });
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    const r = await api.micTrack({ region: f.region, days: f.days, q: f.q.trim(), official: f.official });
    if (r?.status) setD(r);
    setLoading(false);
  }, [f]);
  useEffect(() => {
    setLoading(true);
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const csv = () => {
    const satir = [["ID", "Ad", "Koltukta (dk)", "Mikrofon açık (dk)", "Mikrofon kapalı (dk)", "Gün", "Odalar"]].concat(
      d.totals.map((t) => [t.uniqueID, t.name, t.seatMin, t.micMin, t.seatMin - t.micMin, t.days, (t.rooms || []).join(" / ")])
    );
    const metin = "\ufeff" + satir.map((r) => r.map((x) => `"${String(x ?? "").replace(/"/g, '""')}"`).join(";")).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([metin], { type: "text/csv;charset=utf-8" }));
    a.download = `mikrofon_${f.region}_${f.days}gun.csv`;
    a.click();
  };

  return (
    <div style={{ marginTop: 28 }}>
      <h5 style={{ fontWeight: 800 }}>Mikrofon takibi</h5>
      <div style={{ fontSize: 12.5, color: "#6B7280", marginBottom: 10 }}>
        Koltukta oturan herkes her dakika sayılır. "Mikrofon kapalı" süresi 11 Ekim 2026'dan itibaren tutuluyor. Liste 30 saniyede bir yenilenir.
      </div>
      <div className="d-flex flex-wrap align-items-center" style={{ gap: 8, marginBottom: 12 }}>
        <select className="form-control" style={{ maxWidth: 160 }} value={f.region} onChange={(e) => setF({ ...f, region: e.target.value })}>
          <option value="ar">Arap odaları</option>
          <option value="tr">Türk odaları</option>
          <option value="pk">Pakistan odaları</option>
          <option value="all">Hepsi</option>
        </select>
        <select className="form-control" style={{ maxWidth: 170 }} value={f.official} onChange={(e) => setF({ ...f, official: e.target.value })}>
          <option value="">Tüm odalar</option>
          <option value="1">Sadece yönetim odaları</option>
        </select>
        {[
          [1, "Bugün"],
          [7, "7 gün"],
          [30, "30 gün"],
        ].map(([v, l]) => (
          <button key={v} className={`btn btn-sm ${f.days === v ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setF({ ...f, days: v })}>
            {l}
          </button>
        ))}
        <input className="form-control" style={{ maxWidth: 150 }} placeholder="Kişi ID" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} />
        <button className="btn btn-sm btn-outline-secondary" onClick={csv} disabled={!d.totals.length}>
          Excel'e indir
        </button>
      </div>

      <h6 style={{ fontWeight: 700 }}>Şu an koltukta ({d.now.length})</h6>
      <Table
        loading={loading}
        head={["Kişi", "ID", "Oda", "Koltuk", "Mikrofon", "Ne zamandır"]}
        empty="Şu an koltukta kimse yok."
        rows={d.now.map((s) => (
          <tr key={s.userId + s.room + s.seat}>
            <td><Person image={s.image} name={s.name} /></td>
            <td>{s.uniqueID}</td>
            <td>{s.room}{s.official && <span style={{ marginLeft: 6 }}><Chip kind="info">Yönetim</Chip></span>}</td>
            <td>{s.seat + 1}</td>
            <td>{s.mic ? <Chip>Açık</Chip> : <Chip kind="bad">Kapalı</Chip>}</td>
            <td>{gecen(s.since)}</td>
          </tr>
        ))}
      />

      <h6 style={{ fontWeight: 700, marginTop: 16 }}>{f.days === 1 ? "Bugün" : `Son ${f.days} gün`} · kişi başı</h6>
      <Table
        loading={loading}
        head={["Kişi", "ID", "Koltukta", "Mikrofon açık", "Mikrofon kapalı", "Gün", "Odalar"]}
        empty="Bu dönemde kayıt yok."
        rows={d.totals.map((t) => (
          <tr key={t.userId}>
            <td><Person image={t.image} name={t.name} /></td>
            <td>{t.uniqueID}</td>
            <td>{sure(t.seatMin)}</td>
            <td style={{ color: "#059669", fontWeight: 700 }}>{sure(t.micMin)}</td>
            <td style={{ color: "#DC2626" }}>{sure(t.seatMin - t.micMin)}</td>
            <td>{t.days}</td>
            <td style={{ fontSize: 12, color: "#6B7280" }}>{(t.rooms || []).join(", ")}</td>
          </tr>
        ))}
      />
    </div>
  );
};

export default OfficialRooms;
